var _rect, _rect2, _g, _rect3, _g2, _line, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrighten(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 80,
    viewBox: "0 0 78 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333374,
    width: 77.3333,
    height: 80,
    rx: 6,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1007_38",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 0,
    width: 38,
    height: 80
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.3344,
    y: 80,
    width: 80,
    height: 37,
    transform: "rotate(-90 40.3344 80)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1007_38)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4929 14.501C42.3378 14.538 44.0067 15.6058 44.8145 17.266L62.004 52.5959C62.7681 54.1664 62.6426 56.0245 61.6743 57.4779C57.8343 63.2414 51.1399 66.1127 44.7227 65.3904C38.0486 64.6391 32.0415 60.0696 29.6409 51.9629C29.4645 51.367 29.4061 50.7642 29.4522 50.1796L24.7476 58.9377C23.4621 61.3307 20.4813 62.228 18.0897 60.9417C15.6981 59.6554 14.8014 56.6727 16.0869 54.2796L36.0638 17.0903C36.9375 15.4639 38.6479 14.4639 40.4929 14.501ZM31.3284 46.6869C31.8006 46.3177 32.3487 46.0294 32.958 45.8487C35.5613 45.0769 38.297 46.5629 39.0684 49.1679C40.3845 53.6125 43.2044 55.3188 45.8219 55.6134C47.8751 55.8445 50.0238 55.241 51.7163 53.9282L40.1777 30.2128L31.3284 46.6869Z",
    fill: "url(#paint0_linear_1007_38)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1007_38",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 80
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    y: 80,
    width: 80,
    height: 40,
    transform: "rotate(-90 0.333496 80)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1007_38)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4929 14.501C42.3378 14.538 44.0067 15.6058 44.8145 17.266L62.004 52.5959C62.7681 54.1664 62.6426 56.0245 61.6743 57.4779C57.8343 63.2414 51.1399 66.1127 44.7227 65.3904C38.0486 64.6391 32.0415 60.0696 29.6409 51.9629C29.4645 51.367 29.4061 50.7642 29.4522 50.1796L24.7476 58.9377C23.4621 61.3307 20.4813 62.228 18.0897 60.9417C15.6981 59.6554 14.8014 56.6727 16.0869 54.2796L36.0638 17.0903C36.9375 15.4639 38.6479 14.4639 40.4929 14.501ZM31.3284 46.6869C31.8006 46.3177 32.3487 46.0294 32.958 45.8487C35.5613 45.0769 38.297 46.5629 39.0684 49.1679C40.3845 53.6125 43.2044 55.3188 45.8219 55.6134C47.8751 55.8445 50.0238 55.241 51.7163 53.9282L40.1777 30.2128L31.3284 46.6869Z",
    fill: "url(#paint1_linear_1007_38)"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40.5,
    y1: -2.18557e-8,
    x2: 40.5,
    y2: 80,
    stroke: "url(#paint2_linear_1007_38)",
    strokeOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1007_38",
    x1: 7.02659,
    y1: 65.0024,
    x2: 48.6593,
    y2: 13.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECFABD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1007_38",
    x1: 7.02659,
    y1: 65.0024,
    x2: 48.6593,
    y2: 13.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A844D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDD372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1007_38",
    x1: 40,
    y1: 80,
    x2: 40,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrighten);
export default __webpack_public_path__ + "static/media/brighten.0b6e6e3fdcd87bd0912aaa9ee1f7f806.svg";
export { ForwardRef as ReactComponent };